<template>
  <div class="auth-page">
    <div class="auth-page__container">
      <div>
        <div></div>
        <div class="auth-page__body">
          <div class="h1">Login</div>
          <v-form @submit.prevent="submit">
            <v-layout style="margin: 0 -12px" wrap>
              <v-flex xs12 class="pa-3">
                <v-text-field
                  label="Email*"
                  v-model="form.email"
                  type="email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12></v-flex>
              <v-flex xs12 class="pa-3">
                <v-text-field
                  label="Password*"
                  v-model="form.password"
                  type="password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-3">
                <v-layout justify-space-between align-center>
                  <v-btn color="red" type="submit" @click="submit">Login</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
          <!-- <div>
            <small
              ><router-link to="/forgot-password"
                >Forgot password?</router-link
              ></small
            >
          </div> -->
          <div>
            <small
              ><router-link to="/send-login-link"
                >Send me a link to log in</router-link
              ></small
            >
          </div>

          <Recaptcha />
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {}
    };
  },
  created() {
    if (this.currentUser) {
      this.$router.replace("/");
    }
  },
  methods: {
    async submit() {
      this.form.recaptcha = await this.$recaptcha("login");
      await this.$store.dispatch("auth/login", this.form);
      this.$router.push("/");
    }
  }
};
</script>

<style scoped lang="scss">
.auth-page__body {
  max-width: 560px;
  margin: 0 auto;
  padding: 0 30px;
}
</style>
